// extracted by mini-css-extract-plugin
export default {"container":"menu_container__QpEwa","nav":"menu_nav__VSI4s","close_btn":"menu_close_btn__5LaYJ","overflow":"menu_overflow__ZbVwf"};